import _ from 'lodash';
import { useSelector } from 'react-redux';
import {
  selectCheckoutState,
  selectPreCheckoutState
} from '../../../store/cart/selector';
import { getErrorIMSDescription } from '../../../utils/utils';

const useCheckout = () => {
  const preCheckoutState = useSelector(selectPreCheckoutState);
  const checkoutState = useSelector(selectCheckoutState);

  const isPreCheckoutFailed = preCheckoutState.isFailed;
  const isCheckoutFailed = checkoutState.isFailed;
  let errorCode = 0;
  let errorDescription;
  let errorDetail;

  if (isPreCheckoutFailed) {
    errorCode = _.get(preCheckoutState.payload, 'error.code', 0);
    errorDescription = getErrorIMSDescription(preCheckoutState.payload);
    errorDetail = _.get(preCheckoutState.payload, 'error.detail', {});
  }

  if (isCheckoutFailed) {
    errorCode = _.get(checkoutState.payload, 'error.code', 0);
    errorDescription = getErrorIMSDescription(checkoutState.payload);
    errorDetail = _.get(preCheckoutState.payload, 'error.detail', {});
  }

  return {
    hadFailure: isPreCheckoutFailed || isCheckoutFailed,
    errorCode,
    errorDescription,
    errorDetail
  };
};

export default useCheckout;
